import { inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, take, filter, switchMap, catchError } from 'rxjs/operators';
import * as fromRoot from '../reducers';
import { GatingServices } from '../modules/core/services/gating.services';
import { NavigateToError } from '../actions/olci';
import { GuestDetailsService } from '../modules/core/services/guest-details.service';
import { GuestService } from '../modules/core/services/guest.service';
import { LoadPdetailAction } from '../actions/guest.actions';

export const loggedInGuestLoyaltyGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean =>   {
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
	const guestService: GuestService = inject(GuestService);
	const guestDetailsService: GuestDetailsService = inject(GuestDetailsService);
	const gatingService: GatingServices = inject(GatingServices);	
	return store.pipe(
		select(fromRoot.getSessionState),
		filter(resData => resData.reservationRetrievalResp !== null || !!resData.error),
		take(1),
		switchMap(resData => {
			if (resData.error) {
				store.dispatch(new NavigateToError());
				return of(false);
			} else {
				if (gatingService.hasLoyalty() || !guestService.loggedInGuestPaxId || hasLoyaltyFlagInStore(guestDetailsService)) {
					return of(true);
				}

				store.dispatch(new LoadPdetailAction(guestService.loggedInGuestPaxId));

				return store.pipe(
					select(fromRoot.guestDetailsState),
					filter(pInfo => {
						return pInfo.loading === false || !!pInfo.error;
					}),
					take(1),
					map(pInfo => true),
					catchError(error => {
						return of(true);
					})
				);
			}
		})
	); 
}

const hasLoyaltyFlagInStore = (guestDetailsService: GuestDetailsService): boolean => {
	return guestDetailsService.snapshot.loggedInGuestHasLoyalty !== null;
} 
